// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Qra3d","button__disabled":"Button_button__disabled__w54Cw"};